import React from 'react';
import { BillingProductCard } from './BillingProductCard';
import { PlanUsageType } from '~/types/models';
import cx from 'classnames';
import { AnimatedDiv } from '@vimily/bonjoro-ui-components-v2/AnimatedDiv';

export interface FallbackProductSummaryProps {
  usage: number;
  price: number;
  billingDate?: string;
}

export function FallbackProductSummary({
  usage,
  price,
  billingDate,
}: FallbackProductSummaryProps) {
  return (
    <AnimatedDiv show>
      <BillingProductCard
        label={
          <span className='flex flex-row gap-x-3'>
            <span
              className={cx([
                '!w-[30px] !h-[30px] flex !p-1 !v2-border-neutral-300',
                '!cursor-default  p-1.5 rounded transition-all cursor-pointer',
                'border border-solid v2-border-neutral-100 hover:!v2-bg-blue-50',
              ])}
            >
              <i className='!w-5 !h-5 !v2-bg-turquoise icon icon-timer' />
            </span>
            Video Messaging: Fallback videos
          </span>
        }
        usages={[
          {
            title: PlanUsageType.FallbacksSent,
            count: usage,
            limit: 0,
          },
        ]}
        billingDate={billingDate}
        basicPrice={`$${price?.toLocaleString()}`}
        hideAddOns
        hideBillingDate={billingDate == undefined}
        hideCta
        hideTotalPrice
      />
    </AnimatedDiv>
  );
}
